<template>
  <transition v-on:after-enter="setFocus" name="modal">
    <div class="modal-mask" tabindex="-1" @keyup="keyup">
      <div class="modal-wrapper" @click="clickMask">
        <div
          class="modal-container"
          :style="{'width':`${size}rem`}"
          :class="{'no-padding':!padding}"
        >
          <div class="modal-header">
            <slot name="header"></slot>
            <img class="close-icon" v-if="showCloseIcon" @click="close" :src="closeIcon" alt />
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import imgs from "../../core/images";
export default {
  name: "modal",
  props: {
    showCloseIcon: {
      type: Boolean,
      default: false
    },
    size: {
      default: 30,
      type: [Number, String]
    },
    padding: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    keyup(e) {
      let key = e.key || e.code;
      let code = e.keyCode || e.which;
      if (code === 13 || key === "Enter") {
        this.$emit("send", e);
        return this.preventDefault(e);
      } else if (code === 27 || key === "Escape") {
        if (e.target === e.currentTarget) {
          this.$emit("escape", e);
        } else {
          e.target.blur();
        }
        return this.preventDefault(e);
      }
    },
    preventDefault(event) {
      event.preventDefault();
      return false;
    },
    clickMask(e) {
      if (e.target === e.currentTarget) {
        this.$emit("click-mask", e);
      }
    },
    close() {
      this.$emit("close");
    },
    setFocus() {
      this.$el.focus();
    }
  },
  computed: {
    closeIcon: () => imgs.close
  }
};
</script>

<style lang="scss">
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-mask {
  top: 0;
  left: 0;
  width: 100%;
  border: none;
  height: 100%;
  z-index: 999;
  outline: none;
  display: table;
  position: fixed;
  transition: opacity 0.15s ease;
  background-color: rgba(0, 0, 0, 0.2);
  -webkit-transition: opacity 0.15s ease;
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
      border: none;
      padding: 2rem;
      max-width: 90% !important;
      margin: auto;
      max-height: 80%;
      overflow-y: auto;
      overflow-y: overlay;
      position: relative;
      background-color: #fff;
      transition: all 0.3s ease;
      border-radius: $border-radius;
      -webkit-transition: all 0.3s ease;
      -webkit-box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2),
        0 40px 77px 0 rgba(0, 0, 0, 0.22);
      box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2),
        0 40px 77px 0 rgba(0, 0, 0, 0.22);
      @media (max-width: 520px) {
        width: auto !important;
      }

      $heights: 1000 900 800 700 600 500 400;
      @each $h in $heights {
        $height: #{$h}px;
        $displayHeight: #{$h * 0.7}px;
        @media (max-height: #{$height}) {
          max-height: #{$displayHeight};
        }
      }

      &.no-padding {
        padding: 0;
      }
      .modal-header {
        position: relative;
        .close-icon {
          top: 0;
          bottom: 0;
          margin: auto;
          right: 0.5rem;
          cursor: pointer;
          position: absolute;
        }
      }
    }
  }
}
</style>
